import { Route } from 'react-router-dom'
import { t } from 'ttag'

import About from './About'
import ParentGuide from './ParentGuide'
import LoginBenefits from './LoginBenefits'

import { updatePageTitle } from '../../actions/pageInfo'

function AboutRoutes(dispatch) {
  return (
    <>
      <Route path="/about" component={About} />
      <Route path="/info/parents" component={ParentGuide} />
      <Route
        path="/benefits"
        component={LoginBenefits}
        onEnter={(nextState, replace, callback) => {
          dispatch(updatePageTitle(t`Why Register?`))
          callback()
        }}
      />
    </>
  )
}

AboutRoutes.propTypes = {}
AboutRoutes.defaultProps = {}

export default AboutRoutes
